import { render, staticRenderFns } from "./kw_name_value.vue?vue&type=template&id=2dabd535&scoped=true&"
import script from "./kw_name_value.vue?vue&type=script&lang=js&"
export * from "./kw_name_value.vue?vue&type=script&lang=js&"
import style0 from "./kw_name_value.vue?vue&type=style&index=0&id=2dabd535&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dabd535",
  null
  
)

component.options.__file = "kw_name_value.vue"
export default component.exports